import { ActionIcon, Group, Kbd, UnstyledButton } from "@mantine/core";

import { IconSearch } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

import { getShortcutLabel } from "../utils/get-shortcut-label";

import classes from "./OmniSearchTrigger.module.css";

type OmniSearchTriggerProps = {
  /** Opens the search. */
  onOpen: () => void;
};

const TRIGGER_LABEL = "Search modules and settings";
const KEYBOARD_SHORTCUTS = "Meta+K Control+K";

/**
 * The header's entry point to search. From `sm` up it looks like a search field with the shortcut
 * hint; below `sm` it is an icon button. Both open the same search.
 */
export function OmniSearchTrigger({ onOpen }: OmniSearchTriggerProps) {
  return (
    <>
      <UnstyledButton
        h={36}
        px="sm"
        w="100%"
        maw={420}
        bdrs="xs"
        bg="white"
        visibleFrom="sm"
        onClick={onOpen}
        bd="1px solid gray.4"
        className={classes.field}
        aria-label={TRIGGER_LABEL}
        data-testid="omni-search-trigger"
        aria-keyshortcuts={KEYBOARD_SHORTCUTS}
      >
        <Group gap="xs" wrap="nowrap" justify="space-between">
          <Group gap="xs" wrap="nowrap">
            <IconSearch size={16} aria-hidden color="var(--mantine-color-gray-7)" />
            <TextWrapper size="sm" c="gray.7">
              {TRIGGER_LABEL}…
            </TextWrapper>
          </Group>
          <Kbd size="sm">{getShortcutLabel()}</Kbd>
        </Group>
      </UnstyledButton>
      <ActionIcon
        size="lg"
        color="dark"
        hiddenFrom="sm"
        variant="subtle"
        onClick={onOpen}
        aria-label={TRIGGER_LABEL}
        aria-keyshortcuts={KEYBOARD_SHORTCUTS}
        data-testid="omni-search-trigger-icon"
      >
        <IconSearch size={20} aria-hidden />
      </ActionIcon>
    </>
  );
}
